import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function hideRefundFormDialog(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_REFUND_FORM_DIALOG);
}
